import { CheckIcon, WarningIcon } from 'modules/design-system/icons';
// biome-ignore lint/style/noRestrictedImports: Notification is the only wrapper allowed to use react-toastify
import { ToastContainer, type ToastContainerProps } from 'react-toastify';
import { useTheme } from 'styled-components';
import { NotificationContainerWrapper } from './NotificationContainer.css';

type NotificationContainerProps = Pick<ToastContainerProps, 'autoClose'>;

export const NotificationContainer = ({
  autoClose,
}: NotificationContainerProps) => {
  const theme = useTheme();

  return (
    <NotificationContainerWrapper>
      <ToastContainer
        {...(autoClose === undefined ? {} : { autoClose })}
        hideProgressBar
        closeButton={false}
        closeOnClick
        icon={({ type }) => {
          switch (type) {
            case 'success':
              return <CheckIcon color={theme.colors.icon.inverse} />;
            case 'error':
              return <WarningIcon color={theme.colors.icon.inverse} />;
            default:
              return null;
          }
        }}
      />
    </NotificationContainerWrapper>
  );
};
